import { render, staticRenderFns } from "./insuranceManage.vue?vue&type=template&id=0d4adb86&scoped=true&"
import script from "./insuranceManage.vue?vue&type=script&lang=js&"
export * from "./insuranceManage.vue?vue&type=script&lang=js&"
import style0 from "./insuranceManage.vue?vue&type=style&index=0&id=0d4adb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4adb86",
  null
  
)

export default component.exports